<template>
  <div class="input_container">
    <van-field v-model="inputValue" right-icon="user-circle-o"
      :style="{ border: props.isShowError ? '1.5px rgb(229, 64, 33) solid' : (inputValue && !props.isShowError) ? '0.5px solid rgb(83, 193, 84)' : '0.5px solid #1a1e4780' }"
      :type="isShow && props.isPassword ? 'text' : props.fieldType" :maxlength="props.isPassword ? 20 : 'none'"
      :placeholder="props.labelText" :disabled="isDisabled">
      <template #right-icon>
        <div style="display: flex;">
          <van-icon v-if="inputValue && !isDisabled" name="clear" class="custom-clear" @click.stop="onClear" style="padding-right: 15px;" />
          <div v-if="props.isPassword">
            <van-icon v-if="isShow" name="eye-o" size="20" color="#ffffff66" @click="handleShowPassword" />
            <van-icon v-else name="closed-eye" color="#ffffff66" @click="handleShowPassword" size="20" />
          </div>
          <div v-if="props.isOTP">
            <div class="sendOTP" v-if="isLoading">
              <van-loading type="spinner" size="15" />
            </div>
            <div class="sendOTP" v-else-if="isCounting">
              {{ `${countdown}s` }}
            </div>
            <div v-else class="sendOTP" @click="getOTP">
              {{ $t('common.sendOTP') }}
            </div>
          </div>
        </div>
      </template>

      <template #left-icon>
        <div class="leftContainer" v-if="!props.isPassword && props.isshowFlag">
          <img src="@/assets/loginRegister/br_flag.png" alt="" />
          <p class="currencyText">+55</p>
          <div class="line"></div>
        </div>
        <div v-if="props.isPassword" class="leftContainer">
          <img src="@/assets/themeThree/key.png" alt="" width="18px" style="opacity: 0.4;">
        </div>
        <div class="leftContainer" v-if="props.fieldType == 'email'">
          <img src="@/assets/loginRegister/email.png" alt="" width="18px" style="opacity: 0.4;" >
        </div>
      </template>
    </van-field>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import type { FieldType } from 'vant'
import { COUNT_DOWN_TIME, startCountdownCommon } from '@/view/loginRegister/supportScript'

const props = defineProps({
  fieldType: {
    type: String as () => FieldType,
    default: () => 'text'
  },
  isPassword: {
    type: Boolean,
    default: () => false
  },
  labelText: {
    type: String,
    default: () => ''
  },
  isshowFlag: {
    type: Boolean,
    default: () => false
  },
  isShowError: {
    type: Boolean,
    default: () => false
  },
  isOTP: {
    type: Boolean,
    default: () => false
  },
  modelValue: {
    type: String,
    default: ''
  },
  isDisabled: {
    type: Boolean,
    default: () => false
  }
})

const isShow = ref(false)
const inputValue = ref(props.modelValue)
const countdown = ref(COUNT_DOWN_TIME)
const isCounting = ref(false)
const isLoading = ref(false)
let timer: ReturnType<typeof setInterval> | null = null
const emit = defineEmits(['update:modelValue', 'valueChanged', 'getOtp'])

watch(() => props.modelValue, (newVal) => {
  inputValue.value = newVal
})

watch(() => inputValue.value, (newValue: string) => {
  emit('update:modelValue', newValue)
  emit('valueChanged', newValue)
});
const onClear = () => {
  inputValue.value = ''
  emit('update:modelValue', '')
  emit('valueChanged', '')
}
const handleShowPassword = () => {
  isShow.value = !isShow.value
}

const getOTP = () => {
  isLoading.value = true
  emit('getOtp')
}

const loadingFalse = () => {
  isLoading.value = false
}

let clearCountdown: (() => void) | null = null
const startCountdown = () => {
  clearCountdown?.()
  clearCountdown = startCountdownCommon(countdown, isCounting)
}
defineExpose({
  startCountdown,
  loadingFalse
})
</script>
<style scoped>
.input_container>>>.van-field {
  border-radius: 5px;
  background: rgb(0, 37, 37);
  color: #ffffffd9;
  padding: 15px !important;
  margin-top: 20px;
  font-size: 16px;
}

.input_container>>>.van-field__control {
  color: #fff !important;
  padding-left: 10px !important;
}

.input_container>>>.van-field__control::placeholder {
  color: #ffffff66 !important;
}

.input_container>>>.van-field__right-icon {
  color: #76777A !important;
}

.leftContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.currencyText {
  color: #fff;
  padding: 0 10px;
  margin: 0;
  font-size: 16px;
}

.leftContainer img {
  width: 25px;
}

.line {
  width: 3px;
  background-color: rgb(0, 97, 95);
  height: 20px;
  margin-right: 5px;
}

.sendOTP {
  background-image: linear-gradient(90deg, rgb(1, 73, 72) -18%, rgb(15, 177, 175) 122%);
  padding: 5px 10px;
  color: #fff;
  border-radius: 5px;
  min-width: 8vh;
  text-align: center;
  font-size: 13px;
  cursor: pointer;
}
@media (max-width : 400px) {
  .input_container>>>.van-field {
    font-size: 14px;
  }
}
</style>